export const preApplicationFee = 19.99;
export const creditCheckFee = 15.00;